import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Commit the current open transaction.
 *
 * @private
 */
export const commitTransaction = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/transaction/commit', async (_, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/transaction/commit', {
      category: 'rpc',
      type: 'rpc/transaction/commit',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {commitTransaction}',
      { tags: ['rpc', 'transaction'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Commit Transaction Failed',
      error,
    })
  }
})
